<template lang="pug">
div
  section.u-mt-md
    AppTitle.u-mb-0(:title="$t('mantra')")


  section.u-mt-md
    .grid.is-tablet-6
      .column.u-mb-sm(v-for="item,idx in $t('sec1Items')")
        h4 {{item.title}}
        p.u-mb-ts {{item.desc}}
        AppLink(v-if="item.url" :to="item.url" :title="$t('learnMore')" class="button-link is-small") {{$t('learnMore')}}

  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-mi(:title="$t('sec2')" tag="h2")
      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-sm(v-for="item,idx in $t('sec2Items')")
            h4 {{item.title}}
            p {{item.desc}}

  section.u-mt-md.u-mb-md
    AppLink(to="/ordering" :title="$t('cta')" class="button-link is-large " v-html="$t('cta')")

</template>

<script>
export default {
  head() {
    const $t = this.$t.bind(this);
    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:image',
          name: 'og:image',
          property: 'og:image',
          content: 'https://cdn.baianat.com/static/share/services.png'
        },
        {
          hid: 'twitter:image',
          name: 'twitter:image',
          property: 'twitter:image',
          content: 'https://cdn.baianat.com/static/share/services.png'
        }
      ]
    };
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Baianat user experience consulting",
    "pageDesc":"Providing UX consulting for enterprises and companies to increase conversion rates, drive sales and delight users.",
    "mantra":"Consulting you for a |better user experience.",
    "sec1Items":{
      "1":{
        "title":"Usability testing ",
        "desc":"Examining your app/website against the subaility best practices. Making sure that your users will find it easy to navigate through the experience designed.",
        "url":"/services/usability"
      },
      "2":{
        "title":"A/B testing",
        "desc":"Creating different versions of your app/website and comparing them to figure out which one achieves better engagement."
      },
      "3":{
        "title":"UX Writing",
        "desc":"Ensure that every page, CTA and error message is written with regard to user conceptual models and free of jargon."
      },
      "4":{
        "title":"Information architecture",
        "desc":"Examining your current information hierarchy, audienting for hidden information and suggesting page edits that makes it easy for users to access information."
      }
    },
    "sec2":"User centered testing process.",
    "sec2Items":{
      "1":{
        "title":"Support your business goals",
        "desc":"Get your design to driven by the business needs. Whether its edits in the contact us page or the ordering form, we conduct the necessary tests and set a plan around your goals."
      },
      "2":{
        "title":"Reduce bounce rate",
        "desc":"Simplify your information architecture and use flows that guide users towards their desired end point."
      },
      "3":{
        "title":"Refresh your look and feel",
        "desc":"Redesign using heat maps and analytics based audit to spot on problems and fix issues using best practices."
      }
    },

    "cta":"Revamp your online <br> experience"
  },
  "ar": {
    "pageTitle":"استشارات تجربة المستخدم",
    "pageDesc":"نوفر الإستشارات اللازمة لتجربة المستخدم لكل من المؤسسات والشركات؛ لتحسين تجربة المستخدم وزيادة معدلات التحويل والمبيعات.",
    "mantra":"استشارات تجربة المستخدم |لتجربة وظيفية وفعالة.",
    "sec1Items":{
      "1":{
        "title":"اختبار قابلية الاستخدام ",
        "desc":"نعمل على فحص تطبيقك أو موقعك عن طريق أفضل الممارسات؛ لنتأكد أن المستخدمين سوف يجدون تجربة التصفح سهلة ومألوفة لهم.",
        "url":"/services/usability"
      },
      "2":{
        "title":"أختبار أ/ب",
        "desc":"نساعدك على إنشاء إصدارات مختلفة من التطبيق أو الموقع الخاص بك ومقارنتها جميعًا لمعرفه أيهما أكثر فاعلية ويحقق أفضل النتائج."
      },
      "3":{
        "title":"الكتابة لتجربة المستخدم",
        "desc":"نراجع محتوي موقعك في كل صفحة، ورسالات الخطأ وعبارات الحث على اتخاذ إجراء (CTA) مكتوبة بالشكل المثالى وخالية من الأخطاء؛ لتسهل على المستخدمين التواصل معك."
      },
      "4":{
        "title":"تطوير بنية المعلومات",
        "desc":"نساعد عملائك على استخدام تطبيقك أو موقعك بسلاسة من خلال بنية معلومات منظمة وسهلة الفهم، وتدعم إمكانية الوصول؛ مما يشجعهم على استكشاف ما يقدمه عملك التجاري."
      }
    },
    "sec2":"عمليات الاختبار تتمحور حول المستخدم.",
    "sec2Items":{
      "1":{
        "title":"دعم أهداف عملك.",
        "desc":"احصل على تصميم يتناسب مع المستخدمين وكذلك مع احتياجات عملك. سواء كانت التعديلات على صفحة اتصل بنا أو في نموذج طلب الخدمة، فإننا نجري الاختبارات اللازمة ونضع الخطط حول أهدافك."
      },
      "2":{
        "title":"تقليل معدل الارتداد",
        "desc":"نعمل على تبسيط بينة المعلومات الخاصة بك وكذلك الاعتماد على التدفقات التي توجه المستخدمين نحو نقطة النهاية المطلوبة."
      },
      "3":{
        "title":"تحديث المظهر والانطباع الخاص بك.",
        "desc":"نعمل على إعادة التصميم باستخدام الخرائط الحرارية (heat maps) والتدقيق القائم على التحليلات لتحديد المشاكل وحلها باستخدام أفضل الممارسات."
      }
    },

    "cta":"جدد تجربتك الآن! "
  }
}
</i18n>
